import { useMemo } from 'react'
import { findCheapestOfTourV2Offer } from 'lib/tours/tourUtils'

export default function useCheapestOfTourV2Offer(
  offer: Tours.V2Offer | Tours.V2OfferSummary,
  selectedVariationId?: Tours.V2OfferVariation['id'],
): ReturnType<typeof findCheapestOfTourV2Offer> {
  return useMemo(() =>
    findCheapestOfTourV2Offer(offer, selectedVariationId),
  [offer, selectedVariationId])
}
